if (!customElements.get("expiry-discount")) {
	class ExpiryDiscount extends HTMLElement {
		constructor() {
			super();

			//   this.product = this.getProductData();
			// this.price = this.dataset.price;
			// this.expiryDiscount = this.dataset.expiryDiscount;
			// this.expiryPeriod = this.dataset.expiryPeriod; // in days
			// console.log("variant value", this.dataset.expiryPeriod);
			// this.expiryDate = new Date(this.dataset.expiryDate);

			const productCard = this.closest("product-card");
			if (productCard) {
				this.image =
					this.closest("product-card").querySelector(".discount-img");
			}

			// console.log("this.image", this.image);
		}

		connectedCallback() {
			// This runs when the element is attached to the DOM
			if (this.expiryDiscount && this.expiryPeriod) {
				this.priceCurrent = this.querySelector(".price__current");
				this.priceWas = this.querySelector(".price__was");

				console.log("Prices loaded:", this.priceCurrent);

				// Check if expiry period within the next x days
				const today = new Date();
				const daysFromNow = new Date();
				daysFromNow.setDate(
					today.getDate() + parseInt(this.expiryPeriod)
				);

				console.log("Expiry Date:", this.expiryDate);
				console.log("Days from now:", daysFromNow);

				const newPrice = this.price * (1 - this.expiryDiscount);

				// If days from now is less than expiry date, show discount
				if (this.expiryDate < daysFromNow) {
					this.priceCurrent.innerHTML = this.formatPrice(newPrice);
					this.priceWas.innerHTML = this.formatPrice(this.price);
					if (this.image) {
						this.image.src = this.image.dataset.src;
						this.image.srcset = "";
						this.image.classList.remove("hidden");
					}
				} else {
					console.log("No discount available");
				}
				// Example: if you want to modify price text
			}
		}

		formatPrice = (price) => {
			const dollars = Math.floor(price / 100); // 29
			const cents = price % 100; // 35
			return `${dollars}<sup>${String(cents).padStart(2, "0")}</sup>`;
		};
	}

	customElements.define("expiry-discount", ExpiryDiscount);
}
